<template>
    <div id="detalle">
        <div class="banner">
            <h2>DURAZNO</h2>
        </div>
        <!-- <div class="flotante">
            <img src="@/assets/images/canasta.png" alt="">
        </div> -->
        <div class="inf">
            <div class="btns">
                <div id="btn1" class="btn active" @click="cambio('origen')">ORIGEN</div>
                <div id="btn2" class="btn" @click="cambio('variedades')">VARIEDADES</div>
                <div id="btn3" class="btn" @click="cambio('dis')">DISPONIBILIDAD</div>
                <div id="btn4" class="btn" @click="cambio('prop')">BENEFICIOS</div>
                <!-- <div id="btn5" class="btn" @click="cambio('info')">INFORMACION NUTRIMENTAL</div> -->
            </div>
            <div id="bloques">
                <div id="origen">
                    <!-- <h2></h2> -->
                    <p>
                      El aterciopelado durazno contiene una única semilla encerrada en una cáscara dura, el «hueso».
                      Esta fruta posee una carne amarilla o blanquecina de sabor dulce y aroma delicado.
                      A la variedad que no tiene la piel aterciopelada se la llama nectarina, pavía (En Aragón, Navarra) o pelón.
                    </p>
                    <p>
                      El durazno tiene su origen en la China, donde era considerado un símbolo de larga vida e inmortalidad.
                      Fue dado a conocer gracias  a las persas que transitaban las rutas comerciales de las montañas.
                      Luego fueron llevados a occidente a través de los romanos. De ahí que en algunos países es conocido como Pérsica.
                    </p>
                </div>
                <div id="variedades">
                    <h2>Principales variedades</h2>
                    <ul>
                        <li>Pulpa amarilla: Elegant Lady, O’henry, Prima Gattie</li>
                        <li>Pulpa blanca: Snow Giant, September Snow</li>
                        <li>Otros: Saturno Galaxy (Dona)</li>
                    </ul>
                </div>
                <div id="disponibilidad">
                    <img src="@/assets/images/Durazno-temporada.jpg" alt="">
                </div>
                <div id="propiedades">
                    <p>
                      Pertenece a la familia de las Rosáceas, su cáscara es muy suave, de pulpa dulce y jugosa.
                    </p>
                    <p>
                        El Durazno es fácilmente digerible y tiene una fuerte reacción alcalina sobre todo el cuerpo.
                    </p>
                    <p>
                      Propiedades para adelgazar por su contenido mínimo en calorías.
                    </p>
                    <p>
                      Gran estimulante digestivo y por su contenido en Hierro es recomendable para atender Anemia.
                    </p>
                    <p>
                      Sus vitaminas producen un efecto antioxidante,
                      protege al organismo del envejecimiento y ayuda a prevenir la aparición del Cáncer.
                    </p>
                    <p>
                      Ayuda a bajar los niveles de colesterol nocivo, previene problemas cardiovasculares y degenerativos,
                      estimula la secreción de jugos gástricos y ayuda a controlar los niveles de azúcar en la sangre (apto para diabéticos)
                    </p>
                    <p>
                      Su alto contenido en fibra ayuda a mejorar la digestión, estimula el movimiento intestinal y evita el estreñimiento.
                    </p>
                    <p>
                      Ayuda a prevenir la osteoporosis, debilidad de huesos y dientes, ayuda a hidratar la piel y la reconstrucción de tejidos.
                    </p>
                </div>
                <div id="info-nut">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    cambio(active) {
      const btn1 = document.getElementById('btn1');


      const btn2 = document.getElementById('btn2');


      const btn3 = document.getElementById('btn3');


      const btn4 = document.getElementById('btn4');


      const btn5 = document.getElementById('btn5');


      const origen = document.getElementById('origen');


      const variedades = document.getElementById('variedades');


      const disponibilidad = document.getElementById('disponibilidad');


      const propiedades = document.getElementById('propiedades');
      // inf = document.getElementById('info-nut');


      origen.style.display = 'none';
      variedades.style.display = 'none';
      disponibilidad.style.display = 'none';
      propiedades.style.display = 'none';
      //  inf.style.display='none';

      btn1.className = 'btn';
      btn2.className = 'btn';
      btn3.className = 'btn';
      btn4.className = 'btn';
      //  btn5.className='btn';

      if (active == 'origen') {
        console.log('origen');
        btn1.classList.add('active');
        origen.style.display = 'block';
      } else if (active == 'variedades') {
        console.log('var');
        btn2.classList.add('active');
        variedades.style.display = 'block';
      } else if (active == 'dis') {
        console.log('dis');
        btn3.classList.add('active');
        disponibilidad.style.display = 'block';
      } else if (active == 'prop') {
        console.log('props');
        btn4.classList.add('active');
        propiedades.style.display = 'block';
      } // else{
      //   console.log('info');
      //   btn5.classList.add('active');
      //   inf.style.display='block';
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
#detalle {
  .active {
    background: gray !important;
    display: block;
  }
  .banner {
      height: 50vh;
      background-image: url('../../assets/images/grid/1.jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      h2 {
          position: relative;
          top: 10%;
          color: #fff;
          font-size: 2.2em;
          font-weight: bold;
      }
  }
  .flotante {
      position: relative;
      top: -30vh;;
      z-index: 10;

  }
  .inf {
      // position: relative;
      // top: -30vh;
      .btns {
          margin: 2% auto;
          margin-bottom: 4%;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .btn {
            cursor: pointer;
              width: 200px;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 5px 15px;
              color: #fff;
              background-color: green;
              border-radius: 10px;
              padding: 10px 30px;
          }
          .btn:nth-child(5) {
              width: 300px;
          }
      }
      #bloques {
          text-align: justify;

        > div {
            color: gray;
           font-size: 1.3em;
            margin: 0 20%;
            h2 {
              text-align: center;
            }
        }
        #origen {
          display: block;

          h2 {
            text-align: center;
          }
        }
        #variedades {
            display: none;
        }
        #disponibilidad {
            display: none;
        }
        #propiedades {
            display: none;
        }
        #info-nut {
            display: none;
        }
      }
  }
}
</style>
